module.exports = __webpack_public_path__ + "img/plus.662f1d39.svg";